import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default function initRange() {
  document.querySelectorAll('.range').forEach(holder => {
    const slider = holder.querySelector('.slider')
    const start = holder.querySelector('[data-start]')
    const end = holder.querySelector('[data-end]')

    var formatForSlider = {
      from: function (formattedValue) {
          return Number(formattedValue);
      },
      to: function(numericValue) {
          return Math.round(numericValue);
      }
    };
  
  
    noUiSlider.create(slider, {
        start: [parseFloat(start.innerHTML.replace(',', '')), parseFloat(end.innerHTML.replace(',', ''))],
        connect: true,
        range: {
            'min': parseFloat(slider.dataset.min.replace(',', '')),
            'max': parseFloat(slider.dataset.max.replace(',', ''))
        },
        format: formatForSlider,
    });
    
    var formatValues = [
      start,
      end
    ];
    
    slider.noUiSlider.on('update', function (values, handle, unencoded) {
      let formattedNumber = values[handle].toLocaleString()
        formatValues[handle].innerHTML = formattedNumber;
    });
  })
}
